import { switchMap } from 'rxjs';
import { fromFetch } from 'rxjs/fetch';
import { getCommunityInteractiveSitePlanMarkers } from 'constants/routes'

/**
 * Parses the fetch response into JSON.
 * Throws on non-2xx responses so the observable errors.
 *
 * NOTE:
 * - Consumers are responsible for handling errors (e.g. catchError, retry).
 */
const parseJsonResponse = (response) => {
  if (!response.ok) {
    throw new Error(`HTTP ${response.status}`);
  }

  return response.json();
};

/**
 * Retrieves community interactive site plan markers associated with a given community id list.
 * @param {Object} payload - The payload containing the list of community ids.
 * @returns {Observable} - An observable that emits the community interactive site plans information.
 */
const getCommunityInteractiveSitePlans = (payload) => {
  const queryParams = new URLSearchParams({ communityIds: payload });

  return fromFetch(`${getCommunityInteractiveSitePlanMarkers}?${queryParams.toString()}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
  }).pipe(
    switchMap(parseJsonResponse)
  );
};

export default getCommunityInteractiveSitePlans;